import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
let listeners = [];
export const pushToast = (message, tone) => {
    const toast = { id: Date.now(), message, tone };
    listeners.forEach((listener) => listener(toast));
};
export const ToastViewport = () => {
    const [toasts, setToasts] = useState([]);
    useEffect(() => {
        const listener = (toast) => {
            setToasts((current) => [...current, toast]);
            window.setTimeout(() => {
                setToasts((current) => current.filter((item) => item.id !== toast.id));
            }, 3000);
        };
        listeners.push(listener);
        return () => {
            listeners = listeners.filter((item) => item !== listener);
        };
    }, []);
    return (_jsx("div", { className: "fixed right-4 top-4 z-50 space-y-3", children: toasts.map((toast) => (_jsx("div", { className: `glass-panel-strong rounded-2xl px-4 py-3 text-sm shadow-xl ${toast.tone === 'success'
                ? 'border-emerald-300/60 text-emerald-700 dark:text-emerald-200'
                : 'border-rose-300/60 text-rose-700 dark:text-rose-200'}`, children: toast.message }, toast.id))) }));
};
